import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
// import DeptLeft from '../People/Dept_Left'

const AwardsPeople = [
    {
        "AwardName": "Life Time Achievement Award",
        "About": "Prof KSMS Raghava Rao has been awarded the prestigious  Life Time Achievement Award  by International Association of Engineering and Food. He will receive the award at ICEF14 to be held at Nantes, France in 19-23 June 2023. ",        
        "Image": "https://files.iittp.ac.in/images/demo/iit/raghavarao.png",
        "Name": "Prof KSMS Raghava Rao",
        "NameLink": ""
    },
     {
        "AwardName": "Fellow, Indian National Academy of Engineering",
        "About": "Prof. Muthukumar Palanisamy, Professor, Department of Mechanical Engineering, on being elected as a Fellow, Indian National Academy of Engineering (INAE), effective from 1 November 2025.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg",
        "Name": "Prof. Muthukumar Palanisamy",
        "NameLink": ""
    },
     {
        "AwardName": "Young Associate",
        "About": "Dr. Ranjith Thangavel, Associate Professor, Department of Chemical Engineering, on being elected as a Young Associate of the Indian National Academy of Engineering (INAE) and has been conferred with the INAE Young Engineer Award 2025.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Ranjith_AP.png",
        "Name": "Dr. Ranjith Thangavel",
        "NameLink": ""
    },
     { 
        "AwardName": "ICI Young Scientist Award 2025",
        "About": "Dr. Bijily Balakrishnan, Associate Professor, Department of Civil & Environmental Engineering, IIT Tirupati, on receiving the prestigious Indian Concrete Institute (ICI) Young Scientist Award 2025. ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/bijili.jpg",
        "Name": "Dr. Bijily Balakrishnan",
        "NameLink": ""
    },
     { 
        "AwardName": "DAAD Research Ambassador",
        "About": "Dr. Panchatcharam Mariappan has been selected for the second time as a DAAD Research Ambassador (2025 to 2028), a prestigious recognition awarded by the German Academic Exchange Service (DAAD). ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/PanchatcharamNUMA.jpg",
        "Name": "Dr. Panchatcharam Mariappan",
        "NameLink": ""
    },
    {
        "AwardName": "Assistant Subject Editor, International Journal of Hydrogen Energy, Elsevier [Q1 category, Impact factor 8.1.]",
        "About": "Prof. Muthukumar Palanisamy has been appointed Assistant Subject Editor for the International Journal of Hydrogen Energy, a prestigious Q1 journal in the field of hydrogen energy.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg",
        "Name": "Prof. Muthukumar Palanisamy",
        "NameLink": ""
    },

    {
        "AwardName": "Associate Editor, Journal of Manufacturing Processes (Elsevier)",
        "About": "Prof. Mamilla Ravi Sankar, Professor (Mechanical Engineering) nominated as Associate Editor, Journal of Manufacturing Processes (Elsevier). This is one of the top Manufacturing Journals.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/EVMRS.JPG",
        "Name": "Prof. Mamilla Ravi Sankar",
        "NameLink": ""
    },

    {
        "AwardName": "International Member of the USNAE Transportation Research Board",
        "About": "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Based on his team’s research contributions in the areas of roadway noise and modeling, has been appointed an International Member of the USNAE Transportation Research Board Standing Committee on Transportation-Related Noise and Vibration: 2024-27.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/krishna1.jpg",
        "Name": "Prof. Krishna Prapoorna",
        "NameLink": ""
    },
    {
        "AwardName": "Abdul Kalam Technology Innovation National Fellowship",
        "About": "Prof. Muthukumar Palanisamy was honored with the Abdul Kalam Technology Innovation National Fellowship for the period 2021–2026.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof.Muthukumar.jpg",
        "Name": "Prof. Muthukumar Palanisamy",
        "NameLink": ""
    },

    {
        "AwardName": "Chandran Menon Memorial Award",
        "About": "Dr. Ajay Kumar, Associate Professor (Mechanical Engineering Department) received the Chandran Menon Memorial Award for Applied Research & Innovative Technology for 2022 - 23. The award was given in the 72nd INDIAN FOUNDRY CONGRESS(IFC) on 2nd February 2024, at BIEC, Bengaluru, Karnataka",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Ajay_Kumar_New.png",
        "Name": "Dr. Ajay Kumar",
        "NameLink": ""
    },
    // {
    //     "AwardName": "Fellow of the Institution of Engineers (India)",
    //     "About": "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Elected as Fellow of the Institution of Engineers (India), March 2024.",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/krishna1.jpg",
    //     "Name": "Prof. Krishna Prapoorna",
    //     "NameLink": ""
    // },


   
    {
        "AwardName": "iSMARTi Vice President of South Asia",
        "About": "Prof. Krishna Prapoorna, Professor (Civil & Environmental Engineering) Appointed as iSMARTi Vice President of South Asia.",
        "Image": "https://files.iittp.ac.in/images/demo/iit/krishna1.jpg",
        "Name": "Prof. Krishna Prapoorna",
        "NameLink": "https://www.ismarti.org/"
    },

    // {
    //     "AwardName": "Award for Inclusion Research",
    //     "About": "Dr. Sridhar Chimalakonda (Computer Science & Engineering) has received the 'Award for Inclusion Research' by Google Research in Oct 2023. https://research.google/outreach/award-for-inclusion-research-program/recipients/ ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg",
    //     "Name": "Dr. Sridhar Chimalakonda",
    //     "NameLink": ""
    // },
   
    {
        "AwardName": "exploreCSR Award from Google Research",
        "About": "Dr. Sridhar Chimalakonda (Computer Science & Engineering) has received the exploreCSR Award from Google Research in Oct 2023. https://research.google/outreach/explorecsr/recipients/  ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg",
        "Name": "Dr. Sridhar Chimalakonda",
        "NameLink": ""
    },
   

    // {
    //     "AwardName": "Microsoft Research Accelerate Foundation Models Grant",
    //     "About": "Dr. Sridhar Chimalakonda (Computer Science & Engineering) has received the Microsoft Research Accelerate Foundation Models Grant in Sep 2023. https://www.microsoft.com/en-us/research/project/afmr-creativity-and-design/  ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg",
    //     "Name": "Dr. Sridhar Chimalakonda",
    //     "NameLink": ""
    // },
    
    // {
        
    //     "AwardName": "Member to the panel of Revision of Indian Standard (IS)",
    //     "About": "Dr. B. Janaki Ramaiah co-opted as a member to the panel of Revision of Indian Standard (IS) 4968- “Method for subsurface sounding for soils” and Indian Standard (IS) 10589- “Equipment for subsurface sounding of soils” under BIS Section “Soil and Foundation Engineering CED 43:P14002E”. ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/JanakiRamaiah.jpg",
    //     "Name": "Dr. B. Janaki Ramaiah",
    //     "NameLink": ""
    // },

    

    {
        "AwardName": "Chemical Research Society of India (CRSI)’s Bronze Medal",
        "About": "Prof. Gouriprasanna Roy (Professor, Chemistry) was awarded the Chemical Research Society of India (CRSI)’s Bronze Medal for 2020 in 26th CRSI-National Symposium in Chemistry (CRSI-NSC – 2020), VIT, Vellore, 7 – 9 February 2020, for his significant contributions to chemistry in the area of bioinorganic and coordination chemistry.",
        "Image": "https://files.iittp.ac.in/pics/Gouriprasanna%20Roy-CRSI.jpg",
        "Name": "Prof. Gouriprasanna Roy",
        "NameLink": ""
    },

    // {
    //     "AwardName": "Research Excellence Award",
    //     "About": "Dr. Shihabudhen M. Maliyekkal received Research Excellence Award under the subcategory “Teaching Faculty” at IEI - FCRIT Excellence Award 2019, Mumbai for his contribution to research.",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/Shihab.png",
    //     "Name": "Dr. Shihabudhen",
    //     "NameLink": ""
    // },


    // {
    //     "AwardName": "ACM India Eminent Speaker Program",
    //     "About": "Dr. Sridhar Chimalakonda is now part of the ACM India Eminent Speaker Program through which he can deliver talks in computing at any of the ACM's 180 professional and student chapters across India, and these visits are funded by ACM. You can find more details and invite him through https://www.acm.org/articles/acm-india-esp/sridhar-chimalakonda.  ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/chimalakonda.jpg",
    //     "Name": "Dr. Sridhar Chimalakonda",
    //     "NameLink": ""
    // },



    {
        "AwardName": "Asphalt Rubber Ambassador for India",
        "About": "In recognition of the research contributions made by Prof. Krishna Prapoorna, the Rubber Asphalt Foundation has nominated Prof. Krishna Prapoorna as Asphalt Rubber Ambassador for India ",
        "Image": "https://files.iittp.ac.in/images/demo/iit/krishna1.jpg",
        "Name": " Prof. Krishna Prapoorna",
        "NameLink": ""
    },

    // {
    //     "AwardName": "Eminent Engineer Award 2018",
    //     "About": "Prof. Kamatam Krishnaiah was awarded the “Eminent Engineer Award 2018” on 51st Engineers Day and 158th BirtAwardsPeopleay of Bharat Ratna Sir Mokshagundam Visvesvaraya celebrations on 15-09-2018 by the Institution of Engineers (India), Tirupati Chapter. ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/krishnaiah.jpg",
    //     "Name": " Prof. Kamatam Krishnaiah",
    //     "NameLink": ""
    // },

    // {
    //     "AwardName": "Eminent Scientist",
    //     "About": "Prof. T.S Natarajan recently received “Eminent Scientist” Science & Technology Award by KG Foundation, Coimbatore, for his contribution to Science in Educational Institutions. ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/TSN.jpg",
    //     "Name": " Prof. T.S Natarajan",
    //     "NameLink": ""
    // },

    // {
    //     "AwardName": "Life Time Achievement",
    //     "About": "Prof. K. Krishnaiah recently received “Life Time Achievement Award” for his outstanding life-long contribution to Engineering education and research. ",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/krishnaiah.jpg",
    //     "Name": " Prof. K. Krishnaiah",
    //     "NameLink": ""
    // }

]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Awards" />
            <section className="team-area fix p-relative pt-120 pb-80">
                {/*   */}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Awards
                                </h5>
                                <h3></h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                
                        <Col md={12} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>AWARDS/ACHIEVEMENTS/RECOGNITIONS</h3>
                                {AwardsPeople.map((AwardsPeople, index) => (
                                    <div key={index} className="col-xl-4 col-md-4">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`} style={{ height: '565px', maxHeight: '567px', overflow: 'auto' }}>
                                        {/* <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}> */}
                                            <div className="team-thumb">
                                                <h4>
                                                    <Link to={AwardsPeople.NameLink}>{AwardsPeople.AwardName}</Link>
                                                </h4>
                                                <div className="brd mt-3">
                                                    <Link to={AwardsPeople.NameLink}>
                                                        <img  style={{height:"250",width:"250"}} src={AwardsPeople.Image} alt="Image" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                    <div className="text-dark text-left c-lineheight2dot5">                                                    
                                                    <p className="text-dark">{AwardsPeople.About}</p>                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                           




                           
                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main